<div class="modal-body">
  <div class="p-3">
    <h4>Linked to Club Hub Case {{s365Data?.reference}}</h4>
    <div>
      <p>You're about to return to the Ignite main menu.</p>
      <p>Would you like to start a new search or keep your client details?</p>
    </div>
  </div>
  <div class="d-flex">
    <div class="col-6 d-flex flex-column btn-col p-3">
      <button
        type="button"
        class="btn btn-outline-colour-grayscale-900 w-100 h-100"
        (click)="keepDetails()"
      >
        Keep details
      </button>
    </div>
    <div class="col-6 d-flex flex-column btn-col p-3">
      <button
        type="button"
        class="btn btn-outline-colour-grayscale-900 w-100 h-100"
        (click)="newSearch()"
      >
        New search
      </button>
    </div>
  </div>
</div>
